import React, { useState } from 'react'
import { ConnectorForm } from '@/features/connectors'
import Modal from '@/components/ui/Modal'
import { ReactComponent as ConnectorIcon } from '@/assets/icons/connector.svg'
import { useHandleClose } from './ConnectorModal.hooks'
import Typography from '@/components/ui/Typography'
import { Connector } from '@knots/api-sdk'
import { systems } from '@knots/shared-frontend'

export type ConnectorModalProps = {
  projectId: number
  connector?: Connector
  onClose: () => void
}

export const ConnectorModal = ({ onClose, projectId, connector: initialConnector, ...props }: ConnectorModalProps) => {
  const handleClose = useHandleClose(onClose)
  const [system, setSystem] = useState<Connector['system']>(initialConnector?.system ?? 'ZENDESK')
  const connector = initialConnector ?? ({ system } as Connector)

  return (
    <Modal onClose={handleClose} isOpen>
      <Modal.Header>
        <div>
          <Modal.Icon>
            <ConnectorIcon />
          </Modal.Icon>

          <Typography variant={'xl'}>{`${connector?.name ?? 'New'} connector`}</Typography>
        </div>
        <div>
          <Modal.Close onClick={handleClose} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="knots-form">
          <label htmlFor={`route_${connector?.id}_runtime`}>Connector system</label>
          <select
            id={`route_${connector?.id}_runtime`}
            disabled={!!connector?.id}
            value={system}
            onChange={(e) => {
              setSystem(e.target.value as Connector['system'])
            }}
          >
            {systems.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
          <ConnectorForm connector={connector ?? { system: 'ZENDESK' }} onCreated={handleClose} />
        </div>
      </Modal.Content>
    </Modal>
  )
}
